import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import {
    declineFundingSourceRequest,
    getFundingSourceService,
    removeFundingSource,
    getDeactivatedUsersService
} from '../../services/fundingSource.service';

const initialState = {
    fundingSourceList: {
        totalCount: 0,
        totalPage: 0,
        fundingSourceData: [],
        deactivatedUsersData: [],
    },
};

export const getFundingSourceList = createAsyncThunk(
    `FUNDING_SOURCE`,
    async (
        {
            page,
            limit,
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await getFundingSourceService(
                page,
                limit
            );
            return response;
        } catch (error) {
            throw rejectWithValue(error);
        }
    }
);

export const deleteFundingSource = createAsyncThunk(
    `DELETE_FUNDING_SOURCE`,
    async (
        {
            sourceId
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await removeFundingSource(sourceId);
            return { ...response, sourceId };
        } catch (error) {
            throw rejectWithValue(error);
        }
    }
);

export const deleteFundingSourceRequest = createAsyncThunk(
    'DECLINE_FUNDING_SOURCE',
    async (
        {
            sourceId
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await declineFundingSourceRequest(sourceId);
            return { ...response, sourceId };
        } catch (error) {
            throw rejectWithValue(error)
        }
    }
)

export const getDeactivatedUsersList = createAsyncThunk(
    `DEACTIVATED_USERS`,
    async (
        {
            page,
            limit,
            searchTerm
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await getDeactivatedUsersService(
                page,
                limit,
                searchTerm
            );
            return response;
        } catch (error) {
            throw rejectWithValue(error);
        }
    }
);

const fundingSourceSlice = createSlice({
    name: 'fundingSourceSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // withdrawal Transactions
        builder
            .addCase(getFundingSourceList.fulfilled, (state, { payload }) => {
                if (!payload?.data?.isError) {
                    const { count, totalPage, fundingSourceDetails } = payload?.data?.data;
                    state.fundingSourceList = {
                        totalCount: count ?? 0,
                        totalPage: totalPage ?? 0,
                        fundingSourceData: [...(fundingSourceDetails ?? [])],
                    };
                }
            })
            .addCase(getFundingSourceList.rejected, (_, { payload }) => {
                toast.error(
                    payload?.response?.data?.message ?? 'Something went wrong!'
                );
            });

        builder
            .addCase(deleteFundingSource.fulfilled, (state, { payload }) => {
                if (!payload?.data?.isError) {
                    toast.success(payload?.data?.message);
                    state.fundingSourceList = {
                        ...current(state.fundingSourceList),
                        fundingSourceData: current(state.fundingSourceList).fundingSourceData.filter((item) => item.id !== payload.sourceId && item)
                    }
                }
            })
            .addCase(deleteFundingSource.rejected, (_, { payload }) => {
                toast.error(
                    payload?.response?.data?.message ?? 'Something went wrong!'
                );
            });
        builder
            .addCase(deleteFundingSourceRequest.fulfilled, (state, { payload }) => {
                if (!payload?.data?.isError) {
                    toast.success(payload?.data?.message);
                    state.fundingSourceList = {
                        ...current(state.fundingSourceList),
                        fundingSourceData: current(state.fundingSourceList).fundingSourceData.filter((item) => item.id !== payload.sourceId && item)
                    }
                }
            })
            .addCase(deleteFundingSourceRequest.rejected, (_, { payload }) => {
                toast.error(
                    payload?.response?.data?.message ?? 'Something went wrong!'
                );
            });

        builder
            .addCase(getDeactivatedUsersList.fulfilled, (state, { payload }) => {
                if (!payload?.data?.isError) {
                    const { count, totalPage, userList } = payload?.data?.data;
                    state.fundingSourceList = {
                        totalCount: count ?? 0,
                        totalPage: totalPage ?? 0,
                        deactivatedUsersData: [...(userList ?? [])],
                    };
                }
            })
            .addCase(getDeactivatedUsersList.rejected, (_, { payload }) => {
                toast.error(
                    payload?.response?.data?.message ?? 'Something went wrong!'
                );
            });

    },
});

export const { } = fundingSourceSlice.actions;

export default fundingSourceSlice.reducer;